const templateUrl = require('./sent-shipment.html');

const app = angular.module('msi.shipments.sentShipment', [
  require('../shipment.controller'),
  require('./sent-shipment-list'),
  require('./sent-shipment-body'),
  require('./sent-shipment-footer'),
  require('./help')
]);

app.component('ogSentShipment', {
  bindings: {
    shipment: '<ogFor'
  },
  controller: 'ShipmentController',
  templateUrl: templateUrl
});

module.exports = app.name;
